import MapMarkerQuestionType from './MapMarkerQuestionType';
export default MapMarkerQuestionType;
